import React from 'react'

interface TagInputProps {
  tags: string[]
  setTags: (tags: string[]) => void
  bulkInput: string
  setBulkInput: (value: string) => void
}

const TagInput: React.FC<TagInputProps> = ({tags, setTags, bulkInput, setBulkInput}) => {
  const handleRemoveTag = (tagToRemove: string) => {
    const updated = tags.filter((tag) => tag !== tagToRemove)
    setTags(updated)
  }

  return (
    <div>
      {tags.length > 0 && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            minHeight: '48px',
            maxHeight: '120px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderRadius: '6px',
            padding: '6px 8px',
            backgroundColor: '#f9f9f9',
            cursor: 'text',
            marginBottom: '12px',
          }}
        >
          {tags.map((tag) => (
            <div
              key={tag}
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#e7f3ff',
                color: '#0d6efd',
                borderRadius: '16px',
                padding: '4px 10px',
                margin: '4px',
                fontSize: '14px',
              }}
            >
              {tag}
              <button
                type='button'
                onClick={() => handleRemoveTag(tag)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#0d6efd',
                  fontWeight: 'bold',
                  marginLeft: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  lineHeight: '1',
                }}
              >
                ×
              </button>
            </div>
          ))}

          <input
            type='text'
            value=''
            disabled
            style={{
              border: 'none',
              outline: 'none',
              flex: 1,
              minWidth: '120px',
              fontSize: '14px',
              margin: '4px',
              backgroundColor: 'transparent',
              color: '#999',
              cursor: 'not-allowed',
            }}
          />
        </div>
      )}

      <div style={{marginTop: tags.length > 0 ? '8px' : ''}}>
        <textarea
          value={bulkInput}
          onChange={(e) => setBulkInput(e.target.value)}
          rows={2}
          style={{
            width: '100%',
            borderRadius: '4px',
            border: '1px solid #ccc',
            padding: '8px',
            fontSize: '14px',
            resize: 'none',
            height: '80px',
          }}
        />
        <i className="bi bi-info-square text-warning"></i>
        <span className="text-warning"> Vous pouvez ajouter plusieurs référencements en les séparant par des virgules.</span>
    </div>
</div>
)
}

export {TagInput}
